import { hideLoader, showLoader } from "../utils/loader";
import { showPhase } from "../utils/phase";
import { checkIfValid } from "./validations";
import { generateUserRequestData } from "../utils/userData";

const BTN_SELECTOR = document.querySelector('#userForm button[type=submit]');

export const submitUser = event => {
    event?.preventDefault();
    if (checkIfValid()) return

    showLoader();

    BTN_SELECTOR.setAttribute('disabled', true);

    const request = generateUserRequestData();

    const xhttp = new XMLHttpRequest();
    xhttp.addEventListener('load', function () {
        if (this.readyState === 4) {
            if (this.status === 200) {
                const json = JSON.parse(this.responseText);
                window.userUuid = json.uuid;
                showPhase('Payment');
                BTN_SELECTOR.removeAttribute('disabled');
                hideLoader();
            } else if (this.status > 300) {
                BTN_SELECTOR.removeAttribute('disabled');
                showPhase('UserError');
                hideLoader();
                console.log(this.status);
            }
        }
    });
    xhttp.addEventListener('error', function () {
        console.log('Something went wrong...');
        BTN_SELECTOR.removeAttribute('disabled');
        showPhase('UserError');
        hideLoader();
    });
    xhttp.open('POST', '/v1/users', true);
    xhttp.setRequestHeader('Content-type', 'application/json');
    xhttp.setRequestHeader('Accept', 'application/json');
    xhttp.send(JSON.stringify(request));
};
